<template>
  <div>
    <div class="pagebox">
      <el-row :gutter="20">
        <el-col :span="6">
          <el-button type="primary" @click="handleAdd">新增项目</el-button>
        </el-col>
      </el-row>
      <el-table :data="tableData" v-loading="loading">
          <el-table-column label="项目名称" align="center" prop="name" />
          <el-table-column label="年份" align="center" prop="yearamount" />
          <el-table-column label="项目类容" align="center" prop="introduce" />
          <el-table-column label="项目状态" align="center" prop="status_text" />
          <el-table-column label="操作" align="center">
            <template slot-scope="scope">
              <el-button icon="el-icon-edit" type="text" v-if="scope.row.status<=1" @click="handleEdit(scope.row)">编辑</el-button>
              <el-button icon="el-icon-edit" type="text" @click="handleView(scope.row)">查看</el-button>
            </template>
          </el-table-column>
      </el-table>
    </div>
  </div>
</template>
<script>
import { getUserProjectList,getCheckUserProject } from "@/api/signUp";
export default {
  data() {
    return {
      tableData: [],
      loading: false,
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    getList() {
      this.loading = true;
      getUserProjectList({
        page: 1,
        limit: 10,
      }).then((res) => {
        this.tableData = res.data.data;
      }).finally(() => {
        this.loading = false;
      });
    },
    handleEdit(row){
      console.log(3-(row.editnum+1));
      const zinum = 3-(row.editnum+1)
      this.$confirm('您有'+ zinum +'次修改项目内容的机会，确认要编辑此项目吗？', '编辑确认', {
        confirmButtonText: '确定编辑',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$router.push({name:'sign',query:{project_id:row.id}});
      }).catch(() => {

      });
    },
    handleView(row){
      this.$router.push({name:'project',query:{project_id:row.id}});
    },
    handleAdd(){

      getCheckUserProject().then((res) => {
        if(res.data.code==1){
          this.$router.push({name:'sign'});
        }else{
          this.$message.error(res.data.msg);
        }
      })
    }
  },
};
</script>
<style lang="scss" scoped>
  .pagebox{
    padding: 20px;
  }
</style>
